var environment = ['development', 'staging', 'production'];
export function currentEnvironment() {
    var environment = process.env.REACT_APP_NODE_ENV;
    if (!isRecognizedEnvironment(environment))
        return;
    return environment;
}
function isRecognizedEnvironment(env) {
    return environment.includes(env || '');
}
